import { Device } from './Native/Device';
import config from 'config';
import { DeviceRole, SetupMessage } from './Native/messages/Setup';

//@ts-ignore
window.careand = {
  debug: {},
};

/*
 * Adds window.careand.debug.*
 * functions to help with development and debugging
 */
if (config.ENVIRONMENT === 'staging') {
  function emitNativeEvent(data: any) {
    const event = new CustomEvent('nativeEvent', { detail: data });
    window.dispatchEvent(event);
  }
  function emitPush(content: any) {
    const message = {
      id: `${Math.random()}`,
      type: 'pushNotificationReceived',
      content,
    };
    emitNativeEvent(message);
  }
  function simulateAndroid() {
    //@ts-ignore
    Device.isAndroid = function () {
      return true;
    };
    //@ts-ignore
    Device.isIOS = function () {
      return false;
    };
    //@ts-ignore
    Device.getMessageHandler = function () {
      return () => {};
    };
  }
  function simulateIOS(role: DeviceRole, tenant: string) {
    //@ts-ignore
    Device.isAndroid = function () {
      return false;
    };
    //@ts-ignore
    Device.isIOS = function () {
      return true;
    };
    //@ts-ignore
    Device.getMessageHandler = function () {
      return () => {};
    };

    const msg: SetupMessage = {
      id: '1',
      type: 'setup' as const,
      content: {
        safeArea: {},
        nativeAppVersion: '9.9.9',
        biometricAuthentication: false,
        clientTenant: tenant,
        clientPlatform: 'ios',
        clientRole: role,
      },
    };

    window.postMessage('nativeEvent', msg as any);
  }
  //@ts-ignore
  Object.assign(window.careand.debug, {
    emitNativeEvent,
    simulateAndroid,
    simulateIOS,
    emitPush,
  });
}

export default (window as any).careand.debug;
